/** Page affichée pour une adresse inconnue. */

import { Link } from 'react-router-dom';

import { EmptyState, PageHeader } from '../components/ui';

/** Route inexistante. */
export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Page introuvable" />
      <EmptyState
        title="Cette adresse ne correspond à aucune page du portail"
        description="Le lien est peut-être obsolète, ou l'élément que vous cherchiez a été supprimé."
        action={
          <Link
            to="/"
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Revenir à l'accueil
          </Link>
        }
      />
    </>
  );
}
